
export const getDefaultState = () => {
  return {
    procoreAccountsList: [],
    showExportToProcoreModal: false,
  };
};
export const state = getDefaultState();
